var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"numberSpan",attrs:{"tabindex":"0"},on:{"focus":_vm.startFocus,"blur":_vm.endFocus}},[_vm._v("\n  "+_vm._s(_vm.isFocused ? _vm.formatFull(_vm.value) : _vm.changeFormat(_vm.value))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }